// extracted by mini-css-extract-plugin
export default {"td":"Row-module__td___hrXzv","tr":"Row-module__tr___pBB9u"};